import { render, staticRenderFns } from "./ContactAddress.vue?vue&type=template&id=cb6c0a86"
import script from "./ContactAddress.vue?vue&type=script&lang=js"
export * from "./ContactAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb6c0a86')) {
      api.createRecord('cb6c0a86', component.options)
    } else {
      api.reload('cb6c0a86', component.options)
    }
    module.hot.accept("./ContactAddress.vue?vue&type=template&id=cb6c0a86", function () {
      api.rerender('cb6c0a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contact/ContactAddress.vue"
export default component.exports